import { render, staticRenderFns } from "./registrations-statistics-card.vue?vue&type=template&id=ba25e810&scoped=true&"
import script from "./registrations-statistics-card.vue?vue&type=script&lang=js&"
export * from "./registrations-statistics-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba25e810",
  null
  
)

export default component.exports